<nb-layout>
  <nb-layout-header fixed>
    <app-header></app-header>
  </nb-layout-header>
   <nb-layout-column>
    <div class="container">
      <router-outlet (activate)="onActivate($event)"></router-outlet>
    </div>
  </nb-layout-column>
  <nb-layout-footer style="z-index: 1;">
    <app-footer></app-footer>
  </nb-layout-footer>
</nb-layout>
